import { useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import { Loader } from "../../../../../../common/components/Loader/Loader";
import { TimesheetOperation } from "../../../../core/_request";
import { HttpStatusCode } from "axios";
import style from "./style.module.scss";
import { DisplayTable } from "../../../../../../common/components/LFTable/DisplayTable";
import { TableTypes } from "../../../../../../common/components/LFTable/Table.model";
import { OperationContext } from "../../CreateOperation";
import { Row, Tag } from "antd";
import { TitleBadge } from "../../components/TitleBadge";

type PropsType = {
  item: {
    key: number;
    label: string;
  };
};

export const TableContent = ({ item }: PropsType) => {
  const [searchParams] = useSearchParams();
  const movement = searchParams.get("movment");
  const { filter } = useContext(OperationContext);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [tableData, setTableData] = useState<any>();
  const [timeoutId, setTimeoutId] = useState<any>(null);

  const sharedOnCell = (row: any, index?: number) => {
    if (row?.isAuxiliary) {
      return { colSpan: 0 };
    }

    return {};
  };

  const columns: TableTypes = [
    {
      title: "Début",
      dataIndex: "startAt",
      render: (startAt: string) => (
        <div className={style.table__cell__date}>{startAt ?? "--"}</div>
      ),
      // onCell: (item, index) => ({}),
    },
    {
      title: "Fin",
      dataIndex: "endAt",
      render: (endAt: string) => (
        <div className={style.table__cell__date}>{endAt ?? "--"}</div>
      ),
    },
    {
      title: "Nature",
      dataIndex: "nature",
      render: (_value: any, row: any) => (
        <div className="">
          {row?.isAuxiliary ? (
            <div className="">
              <span> {row?.auxiliary} </span>
            </div>
          ) : (
            <>
              <div className="">
                <span
                  style={{
                    fontWeight: "600",
                  }}
                >
                  {" "}
                  {_value?.label}{" "}
                </span>
              </div>
              <div className={`${style.table__cell__content} d-flex justify-content-start`}>
                {_value?.detail?.map((item: string, i: number) => (
                  <Tag key={i}>
                    {" "}
                    <span
                      style={{
                        fontSize: "10px",
                      }}
                    >
                      {item}
                    </span>{" "}
                  </Tag>
                ))}
                {/* <span> {?.toString()} </span> */}
              </div>
            </>
          )}
        </div>
        // <div className={style.table__cell__date}>{date ?? "--"}</div>
      ),
      onCell: (row) => ({
        colSpan: row?.isAuxiliary ? 2 : 1,
      }),
    },
    {
      title: "Tonnage (T)",
      dataIndex: "tonnage",
      render: (tonnage: string) => (
        <div className={style.table__cell__date}>{tonnage ?? "--"}</div>
      ),
      onCell: sharedOnCell,
    },
  ];
  useEffect(() => {
    item?.key &&
      movement &&
      filter &&
      getTimeSheetData(item?.key, movement as string, {
        dates: [filter?.teamsCreatedAt],
      });
  }, [item, movement, filter]);

  useEffect(() => {
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [timeoutId]);

  const getTimeSheetData = async (
    teamId: number,
    movment: string,
    params?: any
  ) => {
    try {
      setIsLoading(true);
      const res = await TimesheetOperation.getAllTimesheet(
        movment,
        teamId,
        params
      );
      if (res?.status === HttpStatusCode.Ok) {
        setTableData(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Loader isLoading={isLoading} />
      <div className="my-2" style={{ overflowX: "auto", width: "100%" }}>
        <div className="">
        <div className={style.table__team}>
          <span style={{color: '#383938'}}><strong>Membres de l'équipe</strong></span>
        {tableData?.allStaffs?.map((item: any) => (
            <div className="d-flex gap-2">
              <span> {item?.post} : </span>
              <span
                style={{
                  fontWeight: "bold",
                }}
              >
                {" "}
                {item?.names}{" "}
              </span>
            </div>
          ))}
        </div>
        {tableData?.recapPerHold?.length > 0 && (
          <div className={style.table__recap_container}>
          <p className={style.table__recap_title}><strong>Récapitulatif par cale :</strong></p>
        
          <div className={style.table__recap_badges}>
            {tableData?.recapPerHold?.map((hold: any) => (
              <TitleBadge
                key={hold.holdNumber}
                label={`Cale ${hold.holdNumber}`}
                value={`${hold.totalCount}/${hold.totalTonnage} T`}
              />
            ))}
          </div>
        </div>        
        )}
        </div>
        <div className="mt-2">
          <DisplayTable data={tableData} columns={columns} />
        </div>
      </div>
    </div>
  );
};
